<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
    <div v-if="type=='targetRange'&&columnName=='acBenchmark'" ref="acTargetValue" class="wy-target-number-range">
      <vue-numeric 
        class="input-value input-dollar-value" v-bind:minus="false" separator="," v-bind:precision="2"  v-bind:min="0" 
        :class="{'has-error':((data.value==null)&&data.operator&&data.operator!='-'), 'no-value': data.value==null||data.value===''}" 
        v-model="data.value" placeholder="Enter value"></vue-numeric> 
    </div>
    <div v-else-if="type=='targetRange'" class="wy-target-number-range">
      <input 
        ref="targetInput" 
        type="input" 
        placeholder="Enter value" 
        class="input-value" 
        :class="{'has-error':((data.value==null||data.value=='')&&data.operator&&data.operator!='-'), 'no-value': data.value==null}" 
        v-model="data.value"
        @change="handleChangeTarget" 
        @keypress="checkNumber">
    </div>
    <div v-else-if="columnName=='acTarget'" ref="acTargetMinValue" class="wy-target-number-range">
      <span v-if="localData.prefix" class="company-target-prefix">{{localData.prefix}}</span>
      <vue-numeric 
      class="input-value input-dollar-value" v-bind:minus="false" separator="," v-bind:precision="2"  v-bind:min="0" 
        :class="{'has-error':(localData.minValue!==''&&this.localData.maxValue===''||(localData.minValue!==''&&this.localData.maxValue!==''&&Number(localData.minValue)>Number(this.localData.maxValue))), 'no-value': localData.maxValue==null||localData.maxValue===''}" 
        v-model="localData.maxValue" placeholder="Enter upper limit"></vue-numeric> 
      <span> - </span>
      <span v-if="localData.prefix" class="company-target-prefix">{{localData.prefix}}</span>
      <vue-numeric 
        class="input-value input-dollar-value" v-bind:minus="false" separator="," v-bind:precision="2"  v-bind:min="0" 
        :class="{'has-error':(localData.minValue===''&&this.localData.maxValue!==''||(localData.minValue!==''&&this.localData.maxValue!==''&&Number(localData.minValue)>Number(this.localData.maxValue))), 'no-value': localData.minValue==null||localData.minValue===''}"
        v-model="localData.minValue" placeholder="Enter lower limit"></vue-numeric> 
      <div class="panel-target-icon"><span class="panel-target-svg" />Target</div>
    </div>
    <div v-else class="wy-target-number-range">
      <input 
        ref="targetMinInput" 
        type="input" 
        placeholder="Enter lower limit" 
        class="input-value" 
        :class="{'has-error':(localData.minValue==null&&this.localData.maxValue!=null||(localData.minValue!=null&&this.localData.maxValue!=null&&Number(localData.minValue)>Number(this.localData.maxValue))), 'no-value': localData.minValue==null}" 
        v-model="localData.minValue"
        @change="handleChangeTarget" 
        @focus="handleFocus" 
        @blur="handleBlur" 
        @keypress="checkMinNumber">
      <span v-if="localData.suffix" class="company-target-suffix">{{localData.suffix}}</span>
      <span class="target-dash"> - </span>
        <input 
        ref="targetMaxInput" 
        type="input" 
        placeholder="Enter upper limit" 
        class="input-value" 
        :class="{'has-error':(localData.minValue!=null&&this.localData.maxValue==null||(localData.minValue!=null&&this.localData.maxValue!=null&&Number(localData.minValue)>Number(this.localData.maxValue))), 'no-value': localData.maxValue==null}" 
        v-model="localData.maxValue"
        @change="handleChangeTarget" 
        @focus="handleFocus" 
        @blur="handleBlur" 
        @keypress="checkMaxNumber">
      <span v-if="localData.suffix" class="company-target-suffix">{{localData.suffix}}</span>
      <div class="panel-target-icon"><span class="panel-target-svg" />Target</div>
    </div>
</template>
  
<script>
  import VueNumeric from 'vue-numeric'
  export default {
    name: 'wy-target-number-range',
    props:['controller', 'data', 'rowIndex', 'tableData', 'columnName', 'value', 'type'],
    components: {
      VueNumeric
    },
    data() {
      return {
        localData: {},
        hasMinError: false,
        hasMaxError: false,
        firstTime: true,
        firstTimeAc: true
      }
    },
  
    watch: {
      data(value) {
        this.localData = value
      },
      localData: {
        handler: function(newValue) {
            if(this.type == 'targetRange') {
              if(newValue.value === '') {
                if(this.columnName == 'acBenchmark') {
                    this.localData.value = ''
                    this.tableData[this.rowIndex][this.columnName].isNull = true;
                }
                else {
                  newValue.value = 0;
                  this.tableData[this.rowIndex][this.columnName].value = 0;
                }
              }
              else if(newValue.value == null) {
                this.tableData[this.rowIndex][this.columnName].value = newValue.value;
              }
              else {
                if(this.columnName == 'acBenchmark') {
                  if(Number(newValue.value) > 10) {
                    newValue.value = 10;
                  }
                  if(!this.firstTime) {
                    this.tableData[this.rowIndex][this.columnName].isNull = false;
                  }
                }
                else if(Number(newValue.value) > 100) {
                  newValue.value = 100;
                }
                this.tableData[this.rowIndex][this.columnName].value = Number(newValue.value);
              }
              this.controller.controller.compareDifference(this.tableData, this.controller.controller.tableDataClone)
              this.firstTime = false;
            }
            if(!this.type) {
              if(newValue.minValue === '') {
                if(this.columnName == 'acTarget') {
                  this.localData.minValue = ''
                  this.tableData[this.rowIndex][this.columnName].isNull = true;
                  this.tableData[this.rowIndex][this.columnName].minValue = '';
                }
                else {
                  newValue.minValue = 0;
                  this.tableData[this.rowIndex][this.columnName].minValue = 0;
                }
              }
              else if(newValue.minValue == null) {
                this.tableData[this.rowIndex][this.columnName].minValue = newValue.minValue;
              }
              else {
                if(this.columnName == 'acTarget') {
                  if(Number(newValue.minValue) > 10) {
                    newValue.minValue = 10;
                  }
                  if(!this.firstTimeAc) {
                    this.tableData[this.rowIndex][this.columnName].isNull = false;
                  }
                }
                else if(Number(newValue.minValue) > 100) {
                  newValue.minValue = 100;
                }
                else {
                  newValue.minValue = Number(newValue.minValue)
                }
                this.tableData[this.rowIndex][this.columnName].minValue = Number(newValue.minValue);
              }

              if(newValue.maxValue === '') {
                if(this.columnName == 'acTarget') {
                  //TODO handle error and not allow to save
                  this.tableData[this.rowIndex][this.columnName].maxValue = '';
                  this.localData.maxValue = ''
                  this.tableData[this.rowIndex][this.columnName].isNull = true;
                }
                else {
                  newValue.maxValue = 0;
                  this.tableData[this.rowIndex][this.columnName].maxValue = 0;
                }
              }
              else if(newValue.maxValue == null) {
                this.tableData[this.rowIndex][this.columnName].maxValue = newValue.maxValue;
              }
              else {
                if(this.columnName == 'acTarget') {
                  if(Number(newValue.maxValue) > 10) {
                    newValue.maxValue = 10;
                  }
                  if(!this.firstTimeAc) {
                    this.tableData[this.rowIndex][this.columnName].isNull = false;
                  }
                }
                else if(Number(newValue.maxValue) > 100) {
                  newValue.maxValue = 100;
                }
                else {
                  newValue.maxValue = Number(newValue.maxValue);
                }
                this.tableData[this.rowIndex][this.columnName].maxValue = Number(newValue.maxValue);
              }
              this.controller.controller.compareDifference(this.tableData, this.controller.controller.tableDataClone)
              this.firstTimeAc = false;
            }
            setTimeout(() => {
              if(typeof this.controller.controller.controller.hasError != 'undefined') {
                this.controller.controller.controller.hasError = document.querySelectorAll('.has-error').length > 0;
              }
            }, 0);
        },
        deep: true
      }
    },
    

    methods: {
      handleChangeTarget() {
        this.controller.controller.isEditing = false;
        // this.controller.targetsData[0] = JSON.parse(JSON.stringify(this.tableData[this.rowIndex]));
        this.controller.targetsData[0] = this.tableData[this.rowIndex];
        if(this.controller.controller && this.controller.controller.updatedTargetList) {
          this.controller.controller.updatedTargetList(this.tableData[this.rowIndex]) 
        }
      },

      handleFocus() {
        this.controller.controller.isEditing = true;
      },

      handleBlur() {
        // this.controller.controller.isEditing = false 
      },

      checkMinNumber(event) {
        let value = '';
        var keyCode = event.keyCode || event.which;
        if (keyCode >= 48 && keyCode <= 57) {
          if(this.type == 'targetRange') {
            if(this.localData.minValue != null) {
              value = this.localData.minValue + event.key
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
          else {
            if(this.localData.minValue != null) {
              value =  Number(this.localData.minValue + event.key);
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
        }
        else {
          event.preventDefault()
          return false;
        }
      },

      checkMaxNumber(event) {
        let value = '';
        var keyCode = event.keyCode || event.which;
        if (keyCode >= 48 && keyCode <= 57) {
          if(this.type == 'targetRange') {
            if(this.localData.maxValue != null) {
              value = this.localData.maxValue + event.key
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
          else {
            if(this.localData.maxValue != null) {
              value =  Number(this.localData.maxValue + event.key);
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
        }
        else {
          event.preventDefault()
          return false;
        }
      },

      checkNumber(event) {
        let value = '';
        var keyCode = event.keyCode || event.which;
        if (keyCode >= 48 && keyCode <= 57) {
          if(this.type == 'targetRange') {
            if(this.data.value != null) {
              value = Number(this.data.value + event.key);
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
          else {
            if(this.data.value != null) {
              value = this.data.value + event.key
            }
            let valid = /^\d*$/.test(value); //Integer >= 0
            if(!valid) {
              event.returnValue = false
            }
          }
        }
        else {
          event.preventDefault()
          return false;
        }
      }
    },
    created() {
      if(!this.type) {
        this.localData = JSON.parse(JSON.stringify(this.data));
      }
      else {
        this.localData = this.data//JSON.parse(JSON.stringify(this.data));
      }
    },

    mounted() {
      if(this.$refs.acTargetMinValue) {
        this.$refs.acTargetMinValue.querySelectorAll('.input-value.input-dollar-value').forEach(dom => {
          dom.addEventListener('keypress',(e)=>{
            var keyCode = e.keyCode || e.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
              e.preventDefault();
              return false;
            }
          })
        })
      }
      if(this.$refs.acTargetValue) {
        this.$refs.acTargetValue.querySelectorAll('.input-value.input-dollar-value').forEach(dom => {
          dom.addEventListener('keypress',(e)=>{
            var keyCode = e.keyCode || e.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
              e.preventDefault();
              return false;
            }
          })
        })
      }
    }
  }
  </script>
  
  <style lang="scss">
  .wy-configuration-target-experience-automation .wy-target-number-range {
    margin-left: unset;
    width: 236px;
    .input-value {
      height: 30px;
      width: 100px;
      border: 1px #106FBC solid;
      border-radius: 5px;
      text-align: center;
      background-color: #E8F1FF;
      outline: none;
    }
    .input-value.no-value {
      background-color: #FFF;
      border: 1px #CAD2DA solid;
    }
    .input-value:focus {
      background-color:#FFF;
      border: 1px #106FBC solid;
    }
    .input-value.has-error {
      background-color: #FFF4F4;
      border: 1px #EBAFBA solid;
    }
    .seperator {
      padding: 0px 5px;
      line-height: 2.5;
      color: #CAD2DA;
    }
    .with-error {
      background-color: #FFF4F4;
      border-color: #EBAFBA;
    }
    .panel-target-icon {
      font-size: 14px;
      text-align: right;
      margin-right: 13px;
      margin-top: 10px;
      .panel-target-svg {
        display: inline-block;
        background-image: url('../../assets/icons/icon_target_black.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-position: 0px 0px;
        background-size: 100%;
        position: relative;
        vertical-align: middle;
      }
    }
  }
  span.company-target-prefix {
    margin-right: 5px;
    line-height: 2;
  }
  span.company-target-suffix {
    position: relative;
    top: 7px;
    left: -5px;
  }
  span.cancel-target {
    font-weight: 600;
    cursor: pointer;
  }
  .wy-configuration-target-experience-automation {
    .target-section.ac-target {
      padding-left: 45px !important;
    }
    .benchmark-section.ac-target {
      padding-left: 45px !important;
    }
    .target-header.ac-target-header {
      padding-left: 45px !important;
    }
  }

  .wy-configuration-target-experience-automation .target-section.ac-target .wy-target-number-range {
    width: 260px;
    div.panel-target-icon {
      margin-right: 7px;
    }
  }
  .wy-configuration-target-experience-automation .target-section.bas-target .wy-target-number-range {
    width: 270px;
    span.company-target-suffix {
      top: 0px;
      left: 5px;
    }
    span.target-dash {
      padding: 0px 5px;
    }
    div.panel-target-icon {
      margin-right: 20px;
    }
  }
  .wy-configuration-target-experience-automation .target-section.bas-target span.cancel-target {
    font-weight: 600;
    left: 10px;
    position: relative;
    cursor: pointer;
  }
  </style>
  